class AppWebSocketHelper {

  constructor(url, queryParam = {}, onReceiveMessage, heartBeatMessage) {
    this.url = this._buildUrl(url, queryParam)
    this.socket = null // WebSocket instance
    this.heartbeatInterval = null // Heartbeat interval
    this.onReceiveMessage = onReceiveMessage // Callback for received messages
    this.heartBeatMessage = heartBeatMessage
    // Bind the beforeunload handler to close the WebSocket connection on page reload
    this.handleBeforeUnload = this.handleBeforeUnload.bind(this)
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  }

  _buildUrl(endpoint, queryParam) {
    const url = new URL(endpoint);
    Object.entries(queryParam).forEach(([key, value]) => url.searchParams.append(key, value));
    return url.toString();
  }

  // Method to initialize the WebSocket connection
  connect() {
    try {
      this.socket = new WebSocket(this.url)

      // Event listener for WebSocket connection open
      this.socket.addEventListener('open', () => {
        console.log('WebSocket open')
        this.startHeartbeat()
      })

      // Event listener for receiving WebSocket messages
      this.socket.addEventListener('message', (event) => {
        if (this.onReceiveMessage) {
          this.onReceiveMessage(event.data) // Call the callback with the received message
        }
      })

      // Event listener for WebSocket connection close
      this.socket.addEventListener('close', () => {
        console.log('WebSocket closed')
        this.stopHeartbeat()
      })

      // Event listener for WebSocket errors
      this.socket.addEventListener('error', (error) => {
        console.error('WebSocket error: ', error)
      })
    } catch(e) {
      console.log('Socket::Error', e)
    }
  }

  // Method to send a message via WebSocket
  sendMessage(message) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(message)
    } else {
      console.warn('WebSocket is not open. Cannot send message.')
    }
  }

  // Method to start the heartbeat (every 8 minutes)
  startHeartbeat() {
    this.heartbeatInterval = setInterval(() => {
      console.log('WS State',this.socket.readyState)
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        console.log('Sending heartbeat...')
        const defaultMessage = JSON.stringify({ iType: 'HEARTBEAT', payload: {} })
        this.socket.send(this.heartBeatMessage ? JSON.stringify(this.heartBeatMessage) : defaultMessage) // Send a heartbeat to keep connection alive
      }
    }, 2 * 60 * 1000) // 2 minutes
  }

  // Method to stop the heartbeat
  stopHeartbeat() {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval)
      this.heartbeatInterval = null
    }
  }

  // Method to close the WebSocket connection
  close() {
    if(this.handleBeforeUnload) {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }
    if (this.socket) {
      // console.log('Websocket closed')
      this.socket.close()
      this.socket = null;
    }
    this.stopHeartbeat()
  }

  // Method to handle page unload/reload
  handleBeforeUnload() {
    this.close(); // Close the WebSocket connection before the page reloads
  }

}

export default AppWebSocketHelper



// WEBPACK FOOTER //
// ./src/helpers/AppWebSocketHelper.js